import React from 'react';
import styled from '@emotion/styled';
import css from '@styled-system/css';
import shouldForwardProp from '@styled-system/should-forward-prop';
import PropTypes from 'prop-types';
import { PaddingProps } from 'styled-system';

import BaseBox from '../../internal/components/BaseBox';
import { styledSystemPropsType } from '../../internal/propsType';
import { types } from '../../internal/styles/semanticColorVariant';
import { p } from '../../internal/styles/space';
import sx from '../../internal/styles/sx';
import { WithDivProps } from '../../internal/styles/types';
import { getVariantProp } from '../../internal/styles/utils';
import { BaseCardProps, CardFC, CardProps } from './types';

export const StyledBaseCard = styled(BaseBox, {
  shouldForwardProp: (prop) => shouldForwardProp(prop) && prop !== 'type',
})<WithDivProps<BaseCardProps>>(
  css({
    backgroundColor: 'white',
    boxShadow: '10',
    borderRadius: 'card',
  }),
  getVariantProp({
    prop: 'type',
    variants: {
      branded: {
        borderTop: 3,
        borderColor: 'brandSecondary',
        borderBottom: 'none',
        borderLeft: 'none',
        borderRight: 'none',
      },
    },
  }),
  // TODO: this was made to fix temporary the Popover been cut inside the Card
  // what we really need to do is to have the Popover as absolute position inside the body as Portal
  ({ hideOverflow }) => hideOverflow && { overflow: 'hidden' },
  ({ onClick }) => onClick && { cursor: 'pointer' },
  sx
);

const PaddingBox = styled(BaseBox)<WithDivProps<Pick<PaddingProps, 'p'>>>(
  p,
  ({ onClick }) => onClick && { cursor: 'pointer' }
);

const FooterCard = styled(({ p = 4, ...rest }) => (
  <PaddingBox p={p} {...rest} />
))(
  css({
    borderTop: 1,
    borderColor: 'neutrals.5',
  })
);

const Card: CardFC<WithDivProps<CardProps>> = ({
  children,
  footer = null,
  className,
  type,
  p = 4,
  hideOverflow = false,
  sx,
  ...rest
}) => {
  return (
    <StyledBaseCard
      className={className}
      type={type}
      hideOverflow={hideOverflow}
      sx={sx}
    >
      <PaddingBox p={p} {...rest}>
        {children}
      </PaddingBox>
      {footer}
    </StyledBaseCard>
  );
};

Card.Base = ({ children, ...rest }) => (
  <StyledBaseCard {...rest}>{children}</StyledBaseCard>
);

Card.propTypes = {
  p: styledSystemPropsType,
  footer: PropTypes.node,
  type: PropTypes.oneOf(types),
  hideOverflow: PropTypes.bool,
};

FooterCard.propTypes = {
  p: styledSystemPropsType,
};

export { Card as default, FooterCard };
